<template>
    <v-card elevation="3">
        <v-card-text>
            <div class="header-values">
                <h3 class="value-title">VALOR TOTAL DE EMPENHO: {{ form.valor | currency }}</h3>
            </div>

            <v-row>
                <v-col cols="12" md="3">
                    <TextField title="Nome:" id="nome" :vModel="form.nome" @input="form.nome = $event" :responsive="{
                    lg: 12,
                    md: 12,
                    sm: 12,
                    cols: 12,
                }" disabled />
                </v-col>

                <v-col cols="12" md="3">
                    <TextField title="Documento RBI:" id="documento_sei" mask="####.##.######/####-##"
                        :vModel="form.documento_sei" @input="form.documento_sei = $event" :responsive="{
                    lg: 12,
                    md: 12,
                    sm: 12,
                    cols: 12,
                }" disabled />
                </v-col>

                <v-col cols="12" md="3">
                    <TextField title="Elaborador:" id="elaborador" :vModel="form.elaborador"
                        @input="form.elaborador = $event" :responsive="{
                    lg: 12,
                    md: 12,
                    sm: 12,
                    cols: 12,
                }" disabled />
                </v-col>

                <v-col cols="12" md="3">
                    <TextField title="Valor:" id="valor" :vModel="form.valor" @input="form.valor = $event" :responsive="{
                    lg: 12,
                    md: 12,
                    sm: 12,
                    cols: 12,
                }" disabled />
                </v-col>

                <v-col cols="12" md="12">
                    <TextField title="Descrição:" id="descricao" :vModel="form.descricao"
                        @input="form.descricao = $event" :responsive="{
                    lg: 12,
                    md: 12,
                    sm: 12,
                    cols: 12,
                }" disabled />
                </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <div class="section-container">
                <v-row>
                    <v-col cols="12">
                        <v-subheader class="section-title">
                            Dotação Orçamentária
                        </v-subheader>
                    </v-col>
                </v-row>
                <v-row v-for="(dotacao, dotacaoIndex) in form.dotacoes" :key="`dotacao-${dotacaoIndex}`"
                    class="align-center">
                    <v-col cols="12" md="3">
                        <AutocompleteField title="Dotação Orçamentária:" id="dotacao_orcamentaria"
                            :vModel="dotacao.dotacao" :options="dotacoes" @input="dotacao.dotacao = $event" :responsive="{
                    lg: 12,
                    md: 12,
                    sm: 12,
                    cols: 12,
                }" disabled />
                    </v-col>

                    <v-col cols="12" md="3">
                        <TextField title="Valor Usado:" id="valor_usado" :vModel="dotacao.valor"
                            @input="dotacao.valor = $event" :responsive="{
                    lg: 12,
                    md: 12,
                    sm: 12,
                    cols: 12,
                }" disabled />
                    </v-col>
                </v-row>
            </div>

            <div class="section-container">
                <v-row>
                    <v-col cols="12">
                        <v-subheader class="section-title">
                            Itens de Aquisição
                        </v-subheader>
                    </v-col>
                </v-row>
                <v-row v-for="(item, itemIndex) in form.itensAquisicao" :key="`item-${itemIndex}`" class="align-center">
                    <v-col cols="12" md="3">
                        <AutocompleteField :rules="[(v) => !!v || 'Campo obrigatório não informado.']"
                            title="Tipo de Item:" disabled id="tipos_itens" :vModel="item.tipo_item" :options="itens"
                            @input="item.tipo_item = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" />
                    </v-col>

                    <v-col cols="12" md="3">
                        <TextField title="Número RP:" id="numero_rp" :vModel="item.numero_rp"
                            @input="item.numero_rp = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" disabled />
                    </v-col>

                    <v-col cols="12" md="3">
                        <TextField title="Número Item RP:" id="numero_item_rp" :vModel="item.numero_item_rp"
                            @input="item.numero_item_rp = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" disabled />
                    </v-col>

                    <v-col cols="12" md="3">
                        <TextField title="Código do Item:" id="codigo_item" :vModel="item.codigo_item"
                            @input="item.codigo_item = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" disabled />
                    </v-col>

                    <v-col cols="12" md="3">
                        <TextField title="Descrição:" id="descricao_item" :vModel="item.descricao"
                            @input="item.descricao = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" disabled />
                    </v-col>

                    <v-col cols="12" md="3">
                        <TextField title="Valor Unitário:" id="valor_unitario" :vModel="item.valor_unitario"
                            @input="item.valor_unitario = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" type="number" disabled />
                    </v-col>

                    <v-col cols="12" md="3">
                        <TextField title="Quantidade:" id="quantidade" :vModel="item.quantidade"
                            @input="item.quantidade = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" type="number" disabled />
                    </v-col>

                    <v-col cols="12" md="3">
                        <TextField title="Valor Total:" id="valor_total" :vModel="item.valor_total"
                            @input="item.valor_total = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" type="number" disabled />
                    </v-col>
                </v-row>
            </div>

            <v-row class="footer-actions">
                <v-col cols="12" class="text-right">
                    <v-btn class="clear-button" href="/montar-plano-aquisicao">
                        <v-icon left>mdi-refresh</v-icon>
                        Limpar
                    </v-btn>
                    <v-btn color="primary" @click="emitCopyToRascunho" class="ml-2">
                        <v-icon left>mdi-content-copy</v-icon>
                        Fazer Cópia
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import AutocompleteField from "../../components/fields/autocompleteField/AutocompleteField.vue";
import TextField from "../../components/fields/textField/TextField.vue";
export default {
    props: {
        form: Object,
        dotacoes: Array,
        disabled: Boolean,
        itens: Array,
    },
    components: {
        TextField,
        AutocompleteField
    },
    methods: {
        emitCopyToRascunho() {
            this.$emit('copyToRascunho', this.form);
        },
    },
};
</script>

<style scoped>
.header-values {
    margin-bottom: 24px;
    padding: 16px;
    background-color: #F8FAFC;
    border-radius: 8px;
    border: 1px solid #E5E7EB;
}

.value-title {
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 8px;
}

.section-container {
    background-color: #F8FAFC;
    padding: 24px;
    border-radius: 12px;
    margin-bottom: 16px;
    border: 1px solid #E5E7EB;
}

.section-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: #1F2937;
    padding: 0;
    margin-bottom: 16px;
}

.footer-actions {
    margin-top: 24px;
    margin-bottom: 16px;
}

.clear-button {
    background-color: #F3F4F6 !important;
    color: #374151 !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    text-transform: none !important;
    height: 40px !important;
}

.clear-button:hover {
    background-color: #E5E7EB !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

/* Estilos dos campos seguindo padrão do IndexRepasse.vue */
::v-deep .v-text-field,
::v-deep .v-autocomplete {
    margin: 0;
}

::v-deep .v-text-field .v-input__control,
::v-deep .v-autocomplete .v-input__control {
    min-height: 48px;
}

::v-deep .v-text-field .v-input__slot,
::v-deep .v-autocomplete .v-input__slot {
    border-radius: 8px;
    border: 1px solid #E5E7EB;
    background-color: #F9FAFB;
    transition: all 0.2s ease;
    min-height: 48px;
    padding: 0 16px;
}

::v-deep .v-text-field .v-input__slot:hover,
::v-deep .v-autocomplete .v-input__slot:hover {
    border-color: #16A34A;
    background-color: #FFFFFF;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

::v-deep .v-text-field .v-input__slot:focus-within,
::v-deep .v-autocomplete .v-input__slot:focus-within {
    border-color: #16A34A;
    background-color: #FFFFFF;
    border-width: 2px;
    box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.1);
}

::v-deep label {
    font-size: 0.875rem;
    color: #374151;
    font-weight: 600;
    margin-bottom: 8px;
    display: block;
}

::v-deep .v-text-field input,
::v-deep .v-autocomplete input {
    font-size: 1rem;
    color: #1F2937;
}

::v-deep .v-text-field--outlined fieldset,
::v-deep .v-autocomplete--outlined fieldset {
    border: none;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset,
::v-deep .v-autocomplete--outlined.v-input--is-focused fieldset {
    border: none;
}

::v-deep .v-input--is-disabled .v-input__slot {
    background-color: #F3F4F6 !important;
    border-color: #E5E7EB !important;
    opacity: 0.7;
}

::v-deep .v-input--is-disabled label {
    color: #9CA3AF !important;
}

::v-deep .v-input--is-disabled input {
    color: #6B7280 !important;
}

/* Botões de ação primários */
::v-deep .v-btn.primary,
::v-deep .v-btn[color="primary"] {
    background-color: #16A34A !important;
    color: white !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    text-transform: none !important;
    height: 40px !important;
}

::v-deep .v-btn.primary:hover,
::v-deep .v-btn[color="primary"]:hover {
    background-color: #15803D !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3) !important;
}

/* Mensagens de erro */
::v-deep .v-messages__message {
    color: #DC2626;
    font-size: 0.75rem;
    margin-top: 4px;
}

/* Responsividade */
@media (max-width: 959px) {
    .section-container {
        padding: 16px;
    }
    
    .header-values {
        padding: 12px;
    }
}

@media (max-width: 599px) {
    .value-title {
        font-size: 0.8rem;
    }
    
    .section-title {
        font-size: 1rem;
    }
}
</style>